import React from "react";
import NavBar from "../Layout/Navbar";
import Section from "./Section";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import Marchi from "../components/Marchi";
import Contact from "../components/Contact";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import FooterAlt from '../Layout/FooterAlt';
const Layout1 = () => {
  return (
    <React.Fragment>
      <Preloader />
      <NavBar />
      {/* import Section */}
      <Section leftSide={(<div className="mt-5">
                <div className="text-white text-title fw-bold">
                Siamo specializzati nella Vendita, Noleggio e Manutenzione del vostro generatore di corrente
                </div>
                <div>
                  <Link to="/servizi" className="btn btn-white mt-2 text-title d-none d-md-inline">
                    Richiedi informazioni
                  </Link>{" "}
                </div>
              </div>)} home={true}/>
      <Services />
      {/* <Portfolio /> */}
      {/* <Marchi /> */}
      <Portfolio />
      <Contact />
      <Footer />
      <FooterAlt />
      
    </React.Fragment>
  );
};

export default Layout1;
